import { render, staticRenderFns } from "./CompanyAttachmentsEscalated.vue?vue&type=template&id=105845fc&scoped=true&"
import script from "./CompanyAttachmentsEscalated.vue?vue&type=script&lang=js&"
export * from "./CompanyAttachmentsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAttachmentsEscalated.vue?vue&type=style&index=0&id=105845fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105845fc",
  null
  
)

export default component.exports